import { PageFooter } from "@/features/auth/components/common/page-footer"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"
import { Outlet } from "react-router-dom"

// Retrieve the site key from environment variables
const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY

export default function AuthLayout() {
  return (
    <div className="text-foreground relative flex min-h-screen flex-col items-center">
      <main className="flex w-full flex-1 items-center justify-center p-4">
        {/* Only mount the reCAPTCHA provider when a real site key is configured.
            Passing a placeholder key made grecaptcha throw "Missing required
            parameters: sitekey" (SPEEKE-APP-DN); the auth forms already guard on
            a missing executeRecaptcha. */}
        {recaptchaSiteKey ? (
          <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
            <Outlet />
          </GoogleReCaptchaProvider>
        ) : (
          <Outlet />
        )}
      </main>

      <PageFooter className="mt-auto w-full" />
    </div>
  )
}
